export default "__VITE_ASSET__t1GSlhXT__"